module.exports = {
  MessageBox: {
    Api: {
      Request: {
        Relogin: 'Account is not logged in or offline, please log in.',
        ErrorMsg: 'Error Message: &nbsp;&nbsp;',
        NetworkError: 'Network Error: &nbsp;&nbsp;'
      }
    },
    Button: {
      Confirm: 'confirm',
      Cancel: 'cancel',
      Close: 'close'
    }
  },
  Component:{
    PageHandler:{
      Next: 'Next',
      Previous: 'Previous',
    },
    AlertConfirm:{
      Prompt: 'Prompt',
      SelectQuantity: 'Please select quantity!',
      Confirm:'Confirm',
      Cancel:'Cancel',
    }
  },
  Layout: {
    Header: {
      UserCenter: 'User Center',
      Cart: 'Shopping Cart',
      Address: 'Manage Address',
      Order: 'Order',
      Logout: 'Logout',
      Login: 'Login',
      get_points:'Get Points',
      points_record:'Points Record',
    },
    Menu:{
      HomePage: 'Home',
      Products: 'Products',
      Solutions: 'Solutions',
      Training: 'Training',
      Resources: 'Resources',
      AboutUs: 'About Us',
      Contact: 'Contact Us',
      WifiDesign: 'WIFI Design',
    },
    Footer:{
      Product:'Products',
      Solutions: 'Solutions',
      Training: 'Training',
      CourseInfo:'Course Information',
      CourseSchedule:'Course Schedule',
      Resources: 'Resources',
      Everyday:'Monday - Sunday',
      ContactUs: 'Contact Us',
      Tel: '+86-755-82642594'
    }
  },
  User:{
    UserCenter:{
      UserName: 'Username',
      Account: 'Account',
      Change: 'Click to change',
      Password: 'Password',
      Country: 'Country',
      SelectCountry: 'Select Country',
      Province: 'Province',
      SelectProvince: 'Select Province',
      Points: 'Total Points',
      Redeem: 'Redeem Gift',
      ContactSales: 'Contact Sales',
      Phone: 'Phone',
      Wechat: 'Wechat',
      Save: 'Save',
      AdjustAvatar: 'Adjust Avatar',
      Cancel: 'Cancel',
      Confirm: 'Confirm',
      taobaoid:'taobao id',
      jdid:'jd id',
      taobaoid_exists:'taobao id is exists',
      jdid_exists:'jd id is exists',
      taobaoid_input:'Please enter taobao id',
      jdid_input:'Please enter jd id',
      succ:'successful',
      order_id_required:"Please enter order id",
    },
    ChangePhone:{
      ModifyAccount:'Modify Account',
      VerCode:'Verification Code',
      VCpholder:'Enter code',
      SendCode:'Send Code',
      NewAccount: 'New Account',
      NewAccpholder: 'Enter your new account',
      Back: 'Back',
      Save: 'Save',
      Next: 'Next',
      AccountInvalid: 'Please enter a valid account!',
      TimeResend: 's to resend',
      Empty: 'Please fill all the empty fields!',
      OldSuccess: 'Current account verification succeed!',
      ChangeSuccess: 'New account is successfully modified!',
    },
    ChangePwd: {
      ChangePassword: 'Change Password',
      OldPassword: 'Current Password',
      OldPwdPholder: 'Enter your current password',
      NewPwd: 'New Password',
      NewPwdPholder: 'Enter your new password',
      ConfirmPwd: 'Confirm Password',
      Back: 'Back',
      Save: 'Save',
      Next: 'Next',
      Empty: 'Please fill all the empty fields!',
      OldSuccess: 'Password verification succeed!',
      EnterNewPwd: 'Please enter your new password!',
      PwdNotMatch: "The confirm password doesn't match with your new password!",
      ChangeSuccess: 'Password is successfully changed!',
    },
    ForgotPwd:{
      Forgot:'Forgot Password',
      ID:'Account ID',
      IDph:'Phone Number / Email Address',
      Vercode:'Verification Code',
      VCph:'Enter code',
      SendVC:'Send code',
      NewPwd:'New Password',
      NPwdph:'Enter your new password',
      Cpwd:'Confirm Password',
      Cpwdph:'Confirm your new password',
      Save: 'Save',
      Next: 'Next',
      TimeResend: 's to resend',
      Empty: 'Please fill all the empty fields!',
      VerSuccess:'Verification succeeded',
      PwdNotMatch:"The confirm password doesn't match with your new password!",
      Success: 'Password succesfully changed! Remember to login with your new password next time!',
    }
  },
  Gift:{
    GiftCenter:{
      Search:'Search',
      UserCenter: 'User Center',
      GiftCenter:'Gift Center',
      Category:'Category',
      All: 'All',
      Details: 'Details',
      MyGift: 'My Gift',
      PointsRecord: 'Points Record',
      CurrentPoints: 'Current Points',
      Total: 'Total',
      Gifts: 'Gift(s)',
      TotalPages: 'Total Pages',
      CurrentPages: 'Current Page',
      Pages:'Page(s)',
      Points: 'Points',
      Redeem: 'Redeem Now',
      ConfirmGift: 'Confirm Gift',
      SelectAddress: 'Please select the delivery address!',
      ManageAddress: 'Manage Address',
      AddAddress: 'Add Address',
      ClickSelectAddress: 'Click to select address',
      DefaultAddress: 'Default Address',
      Cancel: 'Cancel',
      Confirm: 'Confirm',
      ConfirmExchange:'Confirm Exchange?',
      ConfirmRedeem: 'Confirm Exchange? This gift can be redeemed directly!',
      RedeemSuccess:'Redeem succeed! Gifts will be sent out within 45 days.',
      lp:'Gift',
      remark:'The gift will not change during the validity period',
    },
    GiftDetail:{
      UserCenter: 'User Center',
      GiftCenter:'Gift Center',
      GiftDetail:'Gift Detail',
      Points:'Points',
      CurrentPoint: 'Your current point',
      Type:'Type',
      Desc:'Description',
      Redeem:'Redeem',
      ConfirmGift:'Confirm Gift',
      SelectAddress: 'Please select the delivery address!',
      ManageAddress: 'Manage Address',
      AddAddress: 'Add Address',
      ClickSelectAddress: 'Click to select address',
      DefaultAddress: 'Default Address',
      Cancel: 'Cancel',
      Confirm: 'Confirm',
      Physical: 'Physical',
      Virtual: 'Virtual',
      ConfirmExchange:'Confirm Exchange?',
      ConfirmRedeem: 'Confirm Exchange? This gift can be redeemed directly!',
      RedeemSuccess:'Redeem succeed! Gifts will be sent out within 45 days.',
    },
    MyGift: {
      UserCenter: 'User Center',
      GiftCenter:'Gift Center',
      MyGift: 'My Gift',
      GiftName: 'Gift Name',
      GiftPoint: 'Gift Point',
      RedeemTime: 'Redemption Time',
      Status:'Status',
      Unprocessed: 'Unprocessed',
      ViewLogistic:'View Logistic',
      ViewNote:'View Note',
      Physical: 'Physical Gift',
      Virtual: 'Virtual Gift',
      Processed: 'Processed',
      LogisticCompany: 'Logistic Company: ',
      ShipmentNumber: 'Shipment Number: ',
    },
    PointRecord:{
      UserCenter: 'User Center',
      GiftCenter:'Gift Center',
      PointRecord: 'Point Record',
      GiftName: 'Gift Name',
      PointExchange: 'Point Exchange',
      BeforeRedemption: 'Before',
      AfterRedemption: 'After',
      RedemptionTime:'Change Time',
      Physical: 'Physical Gift',
      Virtual: 'Virtual Gift',
      Processed: 'Processed',
      Unprocessed: 'Unprocessed',
      type: 'Type',
    }
  },
  Shopping:{
    Cart:{
      OrderCart: 'Order Shopping Cart',
      QuotationCart: 'Quotation Shopping Cart',
      ProductInfo: 'Product Information',
      Price: 'Price',
      Quantity: 'Quantity',
      Amount: 'Amount',
      Action: 'Action',
      Delete: 'Delete',
      Total: 'Total',
      Item: 'Item(s)',
      GrandPrice: 'Grand Price',
      DeleteSelected: 'Delete Selected',
      Checkout: 'Checkout',
      SelectOneItem:'Please select at least one item!',
      Cancel: 'Cancel',
      Confirm: 'Confirm',
      DeleteItem:'Are you sure you want to delete this product?',
      ItemRemoved:'Item removed from cart!',
      DeleteSelectedConfirm:'Are you sure you want to delete the selected product?',
      SelectedDeleted:'Selected item removed from cart!',
      Quote:'Request Quote'
    }
  },
  Address: {
    ManageAddress: {
      AddAddress: 'Add Address',
      Recipient: 'Recipient',
      Phone: 'Phone',
      Address: 'Address',
      Action: 'Action',
      DefaultAddress: 'Default Address',
      Delete: 'Delete',
      SetDefault: 'Set as default',
      Default: 'Default',
      DeleteAddress:'Delete this address? This operation cannot be undone!',
      Cancel: 'Cancel',
      Confirm: 'Confirm',
      AddressDeleted:'Address Deleted!',
      Modify:'Modify'
    },
    SetAddress:{
      AddAddress: 'Add Address',
      ChangeAddress: 'Modify Address',
      Recipient: 'Recipient',
      RecipientPholder: 'Enter recipient name',
      Phone: 'Phone',
      PhonePholder: 'Enter your phone number',
      Country: 'Country',
      SelectCountry: 'Select Country',
      Province: 'Province',
      SelectProvince: 'Select Province',
      City:'City',
      SelectCity:'Select City',
      Area: 'Area',
      SelectArea: 'Select Area',
      DetailedAddress: 'Detailed Address',
      DAPholder: 'Enter detailed address information, such as road, house number, area, building number, unit, etc.',
      DefaultAddress: 'Default Address',
      No:'No',
      Yes: 'Yes',
      Add: 'Add',
      Modify: 'Modify',
      CompleteAll: 'Please fill all the empty fields!',
      InvalidPhone: 'Invalid phone number!',
      AddAddressSuccess: 'Address successfully added!',
      ModifyAddressSuccess: 'Address successfully modified!',
    }
  },
  Order:{
    OrderCenter:{
      Reminder: 'You have no order yet, go to product center!',
      ClickRedirect: 'Click to redirect',
      OrderNumber: 'Order Number',
      TotalPrice: 'Total Price',
      OrderStatus: 'Order Status',
      WaitQuote: 'Wait for quote',
      ReturnPoints: 'Return Point',
      PaymentMethod: 'Payment Method',
      Action: 'Action',
      CancelOrder: 'Cancel Order',
      Refund: 'Refund',
      DeleteOrder: 'Delete Order',
      Point:'Point',
      Price: 'Price',
      Quantity: 'Quantity',
      SelectPayMethod: 'Select Payment Method',
      Alipay: 'Alipay',
      Cancel: 'Cancel',
      Confirm: 'Confirm',
      Unpaid: 'Unpaid',
      Paid: 'Paid',
      Shipped: 'Shipped',
      Received: 'Received',
      Cancelled: 'Cancelled',
      Refunded: 'Refunded',
      Online: 'Online',
      Prepaid: 'Prepaid',
      Quotation: 'Quotation',
      Pending: 'Pending',
      Processed: 'Processed',
      Rejected: 'Rejected',
      CancelOrderConfirm: 'Are you sure you want to cancel this order?',
      OrderCancelled:'Order Cancelled!',
      DeleteOrderConfirm:'Are you sure you want to delete this order?',
      OrderDeleted: 'Order Deleted!',
      ClickPay: 'Click to pay',
      OutOfStock:'out of stock',
      RefundConfirm: 'Are you sure you want to refund this order？',
    },
    OrderConfirm:{
      AddAddress: 'Add Address',
      RequestQuote: 'Request a quote',
      ConfirmOrder: 'Confirm Order',
      SelectAddress: 'Select a delivery address.',
      ManageAddress: 'Manage Address',
      ClickSelectAddress: 'Click to select address',
      DefaultAddress: 'Default Address',
      ShowAllAddress: 'Show all addresses',
      Order: 'Order',
      Name: 'Name',
      Price: 'Price',
      Price2: 'Price',
      Quantity: 'Quantity',
      PaymentMethod: 'Payment Method',
      Alipay: 'Alipay',
      SubmitOrder: 'Submit Order',
      Total: 'Total',
      Item: 'Item(s)',
      GrandPrice: 'Grand Price',
      OrderSubmitted: 'The order has been successfully submitted!'
    }
  },
  Contact:{
    ContactUs: 'Contact Us',
    Name: 'Name',
    Email: 'Email',
    Phone: 'Phone',
    Message: 'Message',
    Swipe: 'Swipe right',
    VerSuccess: 'Succeeded!',
    Send: 'Send',
    Sended:'Feedback sent successfully!',
    TipVerify:'Tip: Swipe right to verify!',
  },
  About:{
    AboutUs: 'About Us',
    Introduce: '<p><br></p><p><span style="font-family:宋体">Dasong Jiaxin Industry (Shenzhen) Co., Ltd. was established on </span><span>September 15, 2015</span><span style="font-family:宋体">. It is a high-tech enterprise integrating R&D and sales. Our mission is to provide safe and reliable network solutions and technical support for different types of enterprises and organisations along with the complete system integration in many areas such as networking, wireless, telecommunications, web application development, technical training and Internet solutions.</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">Internet and network technology</span></b></p><p><span style="font-family:宋体">Our focus is on how to provide our customers with better network systems and consulting services. Internet technology is an essential part of our solution, including firewalls, load balancing, failover, bandwidth management, authentication systems,</span><span>VoIP</span><span style="font-family:宋体">,sensors, remote control, integrated mail,</span><span>website development</span><span style="font-family:宋体">, and new technologies such as virtual private networks</span><span>(VPN)</span><span style="font-family:宋体">. We attach great importance to the development of the Internet and spend much time keeping pace with peer companies of all sizes. Our business is to understand who is providing the best services in the field of communications technology, from devices and software to Internet providers, as well as data communication operators such as telephone companies and related industry providers.</span></p><p><span>&nbsp;</span></p><p><span style="font-family:宋体">When we first started this business, we achieved great success in the field of Local Area Network (</span><span>LAN</span><span style="font-family:宋体">) and Wide Area Network (</span><span>WAN</span><span style="font-family:宋体">), and later began to provide internet integration services. As a distributor of network operating systems and network hardware, we have successfully implemented solutions from leading companies in the industry, including </span><span> Cambium</span><span style="font-family:宋体">, </span><span>Mikrotik</span><span style="font-family:宋体">, </span><span>Ubiquiti</span><span style="font-family:宋体">, </span><span>Cisco</span><span style="font-family:宋体">, </span><span>Ruckus</span><span style="font-family:宋体">, </span><span>Huawei</span><span style="font-family:宋体">, </span><span>OkPortal</span><span style="font-family:宋体">, etc. We offer products and services in this area, as well as customization or development of hardware and software, from pure consulting and design work to completion of installation and integration services. Our goal is to help our customers get a better understanding of the technology they use so that they also able to manage their technical resources better.</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">Our service and technology solutions</span></b></p><p><span style="font-family:宋体">Below is a summary of the solutions and services that we offer. We specialized on technologies related to networking and communication, and also provide software and application development services.</span></p><p><b><span style="font-family:宋体">System Integration and Support.</span></b></p><p><span style="font-family:宋体">• LAN and WAN</span></p><p><span style="font-family:宋体">• Network planning and design</span></p><p><span style="font-family:宋体">• System installation and support</span></p><p><span style="font-family:宋体">• Wireless data communication</span></p><p><span style="font-family:宋体">• Network system programming</span></p><p><span style="font-family:宋体">• Remote communication support</span></p><p><span style="font-family:宋体">• Sensor data network communication</span></p><p><span style="font-family:宋体">• Robot, drone,</span><span>LED</span><span style="font-family:宋体"> network communication</span></p><p><span style="font-family:宋体">• CCTV network</span></p><p><span style="font-family:宋体">• Fiber design, installation and support</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">Internet Solution</span></b></p><p><span style="font-family:宋体">• Internet consultation and support</span></p><p><span style="font-family:宋体">• Firewall and network security</span></p><p><span style="font-family:宋体">• Bandwidth management implant</span></p><p><span style="font-family:宋体">• Load balancing and failover</span></p><p><span style="font-family:宋体">• </span><span>Wi-Fi</span><span style="font-family:宋体"> login verification</span></p><p><span style="font-family:宋体">• </span><span>Wi-Fi</span><span style="font-family:宋体"> marketing</span></p><p><span style="font-family:宋体">• Email integration</span></p><p><span style="font-family:宋体">• </span><span>Website</span><span style="font-family:宋体"> development</span></p><p><span style="font-family:宋体">• Internet technology training</span></p><p><span style="font-family:宋体">• Enterprise Network Bridging</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">Business information system support</span></b></p><p><span style="font-family:宋体">• Information system customization</span></p><p><span style="font-family:宋体">• Disaster recovery</span></p><p><span style="font-family:宋体">• Hardware and software evaluation</span></p><p><span style="font-family:宋体">• Customized training services</span></p><p><b><span>&nbsp;</span></b></p><p><b><span style="font-family:宋体">Application and software development</span></b></p><p><span style="font-family:宋体">• Analysis and design</span></p><p><span style="font-family:宋体">• Software programming services</span></p><p><span style="font-family:宋体">• Component consulting and development</span></p><p><span style="font-family:宋体">• Website and web database application development</span></p><p><span style="font-family:宋体">• Disaster recovery</span></p><p><span style="font-family:宋体">• Contact Management and Customer Relationship Management</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">Customer type</span></b></p><p><span style="font-family:宋体">We provide services for various industries. Below is a list of some of the industries we have helped:</span></p><p><span style="font-family:宋体">• Manufacturing and industry</span></p><p><span style="font-family:宋体">• Medical insurance</span></p><p><span style="font-family:宋体">• Hotel and restaurant industry</span></p><p><span style="font-family:宋体">• Wholesale and retail trade</span></p><p><span style="font-family:宋体">• Nursery landscape</span></p><p><span style="font-family:宋体">• Educational institutions</span></p><p><span style="font-family:宋体">• Logistics</span></p><p><span style="font-family:宋体">• Maintenance service industry</span></p><p><span style="font-family:宋体">• Government agencies</span></p><p><span style="font-family:宋体">• Non-profit organization</span></p><p><span style="font-family:宋体">We know that every organization is unique, so we strive to give our customers the most appropriate customized solution, rather than selling a hot-selling product but not suitable for the customer. We will develop systems based on our customer s needs. With experience in integration and customization, coupled with unique products, we can meet the needs of our customers.</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">Corporate Culture</span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></b></p><p><span style="font-family: 宋体">Mission: Maximize the customer’s benefits.</span></p><p><span style="font-family: 宋体">Vision: Making the internet safer.</span></p><p style="text-indent: 48px"><span style="font-family:宋体">Let us<span style="color:red"> (Dasong Jiaxin) </span>become a trustworthy partner for our customers.</span></p><p><span style="font-family: 宋体">Values: Serving customers, continuous innovation, sustainable development.</span></p><p><span>&nbsp;</span></p><p><br></p>',
  },
  Login:{
    AccountLogin: 'Sign in',
    ID: 'Account ID',
    IDph: 'Phone Number / Email Address',
    Pwd: 'Password',
    PwdPh: 'Enter your password',
    Remember: 'Remember me',
    Forgot: 'Forgot password?',
    Login: 'Login',
    RegHere: 'Sign up',
    Empty: 'Please fill all the empty fields!',
    LoginSuccess: 'Login succeeded!',
    LoginError: 'phone or password error',
  },
  Signup: {
    AccountSignup: 'Sign up',
    SelCountry:'Select Country',
    SCph:'select country',
    SelProvince:'Select Province',
    SPph:'select country',
    Email:'Email',
    Emailph:'Enter your email',
    Phone: 'Phone number',
    Phoneph: 'Enter your phone number',
    Vercode: 'Verification Code',
    VCph: 'Enter the verification code',
    SendVC: 'Send code',
    Pwd: 'Password',
    Pwdph:'Enter your password',
    CPwd: 'Confirm Password',
    Name:'Name',
    InviteCode:'Invitation Code (Optional)',
    ICph:'Enter your invitation code',
    Signup: 'Register',
    LogHere: 'Already have an account? Login here',
    InvalidEmail: 'Please enter a valid email!',
    InvalidPhone: 'Please enter a valid phone number',
    TimeResend: 's to resend',
    Comitting:'Signing you up, please wait...',
    Empty:'Please fill all the required fields!',
    CPwdInvalid: "The confirm password doesn't match with your password",
    Success: 'Register succeeded!',
    AgreeTerm:'Please click to agree to the terms of the agreement first',
    Terms:'Agreement',
    Agree:'Agree',
  },
  Training:{
    Home: 'Home',
    TrainingInfo:'Training Information',
    Intro:'To speed up the understanding of RouterOS-Mikrotik equipment and Ubiquiti equipment, EDCwifi-Simplelink Technology Co., Ltd. first established a certified training partner in China. Through such activities, you can meet people who interested in using Mikrotik or Ubiquiti. EDCwifi is authorized by Mikrotik and Ubiquiti as certified training partners, qualified to conduct training activities, and has produced formal Mikrotik and Ubiquiti registration certificates.',
    CheckCertificate:'Check certificate',
    CertiTraining:'Certification Training',
    MikIntro:'MikroTik training courses are organized and provided by MikroTik training centers around the world. They are attended by network engineers, integrators and managers who want to learn about routing and management of wired and wireless networks using MikroTik RouterOS.',
    TrainingContent:'Training Content',
    UBNTintro:'We are committed to providing professional-quality training to Ubiquiti® customers worldwide. We have designed courses taught by Ubiquiti Certified Training Partners and hosted by Ubiquiti Certified Trainers.',
    UBNTintro2:'Each lesson uses actual equipment by students, combining a trainer-led presentation with practical exercises. We found that most technicians learn well through observation and practice, so we combine a lot of graphical, visual and tactile lab exercises to enhance your learning.',
    CertiTrainer:'MikroTik and Ubiquiti Certified Trainer',
    CertiTrainer2:'MikroTik Certified Trainer',
    CTen: '',
    TCen:'',
    SenLecturer:'Senior Lecturer',
    SLen:'',
    TIen:'',
    Time:'Time',
    Address:'Location',
    Fees:'Traning fees',
    ContactNumber:'Contact number',
    Deadline:'Registration deadline',
    Trainer2:'Mr. Wu',
    Trainer3:'Mr. Chen',
    Mikpop:[{
      title: 'MikroTik—MTCNA Certified Network Associate',
      list: [
        'Mikrotik TCP/IP introduction',
        'RouterOS basic settings',
        'ROS Installation',
        'Firewall Filter, NAT',
        'QOS, Simple Queue',
        'Firewall Mark',
        'Wireless basic settings',
        'Bridging, EOIP',
        'WDS',
        'Static routing, basic OSPF',
        'DHCP、Hotspot',
        'VPN',
        'Proxy',
        'MTCNA Exam'
      ]
    },
    {
      title: 'MikroTik—MTCTCE Certified Traffic Control Engineer',
      list: [
        'Basic Configuration',
        'DHCP, Proxy',
        'Layer 2 Security',
        'Firewall filter, NAT, mangle',
        'L7 Protocol',
        'Quality of Service: Queue',
        'MTCTCE Exam'
      ]
    },
    {
      title: 'MikroTik—MTCWE Certified Wireless Engineer',
      list: [
        'Wireless Standard',
        'Wireless Tools and Basic Settings',
        'Wireless Advanced Settings',
        'Access Management and Virtual AP (VAP)',
        'Wireless Security',
        'WDS',
        'RouterOS MESH',
        'Nstreme Protocol',
        'RouterOS-802.11N Regular Installation',
        'MPLS and VPLS Tunnel',
        'NV2 Protocol',
        'MTCWE Exam',
      ]
    },
    {
      title: 'MikroTik—MTCRE Certified Routing Engineer',
      list: [
        'Simple Routing',
        'Strategic Routing',
        'OSPF',
        ' RIP',
        'VLAN',
        'IP Tunnel',
        'MME MESH',
        'Practical Skills',
        'MTCRE(Advanced Routing) Exam',

      ]
    }],
    Ubntpop:[{
      title: 'Ubiquiti UEWA (Enterprise Wireless Admin)',
      list: [
        'WLAN Standards',
        'WLAN Planning',
        'UAP Deployment',
        'UAP Basic Adoption and Configuration',
        'Analytics',
        'Advanced Management',
        'Guests Network, Portal, and Hotspot',
        'UEWA Online Exam',

      ]
    },
    {
      title: 'Ubiquiti UBWA (Broadband Wireless Admin)',
      list: [
        'RF THEORY',
        'Radio Operation Standards',
        'Radio Modulation',
        'Antenna',
        'Airmax and Ubiquiti features',
        'Layer 2 and Layer 3 Wireless ISP Solutions',
        'UBWA Online Exam',

      ]
    },
    {
      title: 'Ubiquiti UBWS (Broadband Wireless Specialist)',
      list: [
        'Service Providers Introduction',
        'airCAM Cloud Suite Overview',
        'Point-to-Point Network Settings',
        'Point-to-MultiPoint Network Settings',
        'Using airOS-7 toolkit for actual practice',
        'Client and AP Best Practices',
        'UBWS Online Exam',

      ]
    }]
  },
  Resources: {
    Resources: 'Resources',
    Search: 'Search',
  },
  Solutions:{
    All:'All Solutions',
  },
  Products:{
    Search: 'Search product',
    All:'All',
    Quote:'Request Quote',
    Purchase:'Purchase',
    AddCart:'Add to Cart',
    Details:{
      Label:'Label',
      Desc:'Description',
      View:'View',
      Specs:'Specifications',
      APSpecs:'Access Point Specifications',
      SimilarProducts:'Similar Products',
      AddedCart:'Added to cart!',
      QuotedCart:'Added to quotation cart!',
    },
    NoRecomm:'No similar recommendation',
    DownloadPdf:'Download PDF',
    RequestQuote:'Request Quote',
  },
  Home:{
    Brand:'Brands',
    HotProducts:'Hot Products',
    Solutions: 'Solutions',
    News:'News',
    Readmore:'Read More',
    Video:'Video',
  },
  News:{
    MostView:'Most Viewed',
    Related:'Related Articles',
    AllNews: 'all the news'
  },
  OrderDetail:{
    detail:'Detail',
    addr:'Address',
    createtime:'Create time',
    ordersn:'Order sn',
    buytype:'Type',
    orderstatus:'Status',
    paytime:'Pay time',
    LogisticsCompany:'Logistics company',
    LogisticsNo:'Logistics no',
    Ucan:'You can',
    waitprice:'Wait for quote',
    ProductName:'Name',
    Price:'Price',
    Number:'Num',
    Points:'Points',
    TotalPrice:'Total',
    Payment:'Payment',
    UserCenter:'Back',
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js